export default __webpack_public_path__ + "static/media/tj.58a209ea.svg";